module.exports = function getResource(label, vars = []) {
    const resources = {
        mainTitle: 'Vos paniers',
        bopisTitle: `Achat en ligne et ramassage (${vars[0]})`,
        bopisPromo: 'Les promotions et les récompenses admissibles peuvent être ajoutées à la page suivante.',
        bopisSubtotal: 'Sous-total des articles à ramasser',
        shippingTitle: `Panier d’expédition et de livraison (${vars[0]})`,
        shippingPromo: 'Les promotions, les récompenses et les échantillons peuvent être ajoutés à la page suivante.',
        shippingSubtotal: 'Sous-total des articles expédiés',
        linkText: 'Voir le panier',
        linkMessage: 'Il n’y a aucun article dans votre panier d’expédition'
    };
    return resources[label];
};
